import { forwardRef } from 'react';
import Animated from 'react-native-reanimated';
import { modalTestID } from 'src/helpers/testIDs.helper';
import { View } from 'react-native';
import { ICON_NAMES } from '@photosi/rn-components/icon/icon.helper';
import TextLato from '@photosi/rn-components/text/text-lato/TextLato';
import { useFocusableGroups } from 'src/hooks/useFocusableGroup';
import { TestIDs } from 'src/constants/testIDs.constants';
import { ModalBodyProps } from './ModalBody.types';
import { styles } from './ModalBody.styles';
import { observer } from 'mobx-react-lite';
import { useStore } from 'src/contexts/StoreContext';
import { FocusGroups } from '@photosi/rn-components/focus-provider/FocusProvider.constants';
import { CircularButton } from '@photosi/rn-components/buttons/circular-button/CircularButton';
import {
  CIRCULAR_BUTTON_SIZES,
  CIRCULAR_BUTTON_TYPES,
} from '@photosi/rn-components/buttons/circular-button/CircularButton.constants';

export const ModalBody = observer(
  forwardRef(
    (
      { title, subtitle, showHeader, toggleClose, style, style_container, testID, children }: ModalBodyProps,
      overlayRef: any,
    ) => {
      const { i18n } = useStore();
      useFocusableGroups([FocusGroups.MODAL, FocusGroups.MODAL_HEADER, FocusGroups.TOAST_NOTIFICATION]);

      return (
        <View style={styles.overlay}>
          <Animated.View
            style={[styles.modalContainer, style]}
            //@ts-ignore used to avoid CloseModal TouchableOpacity to be selected by web browsers.
            onFocus={() => document.activeElement.blur()}
            ref={overlayRef}
            testID={modalTestID(testID)}
          >
            {showHeader && (
              <View style={styles.header}>
                <View style={styles.left_element}></View>
                <View style={styles.center_element}>
                  <TextLato style={styles.title}>{title}</TextLato>
                  {!!subtitle && <TextLato style={styles.subtitle}>{subtitle}</TextLato>}
                </View>
                <View style={styles.right_element}>
                  <CircularButton
                    onPress={async () => toggleClose()}
                    testID={modalTestID(testID, TestIDs.CLOSE)}
                    accessible={true}
                    accessibilityLabel={i18n.t('actions:close_x', { x: i18n.t('general:modal') })}
                    accessibilityRole="button"
                    iconName={ICON_NAMES.Close}
                    iconStyle={styles.closeIcon}
                    size={CIRCULAR_BUTTON_SIZES.SMALL}
                    type={CIRCULAR_BUTTON_TYPES.ONLY_ICON}
                    focusId={modalTestID(testID, TestIDs.CLOSE)}
                    focusOrder={0}
                    focusGroup={FocusGroups.MODAL_HEADER}
                  />
                </View>
              </View>
            )}
            <View style={[styles.content, style_container]}>{children}</View>
          </Animated.View>
        </View>
      );
    },
  ),
);
